import { render, staticRenderFns } from "./PeopleDetail.vue?vue&type=template&id=915af26e&scoped=true&"
import script from "./PeopleDetail.vue?vue&type=script&lang=js&"
export * from "./PeopleDetail.vue?vue&type=script&lang=js&"
import style0 from "./PeopleDetail.vue?vue&type=style&index=0&id=915af26e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "915af26e",
  null
  
)

export default component.exports